import sdk from '@/sdk';
import * as store from '@/store';

import {ServerConfig} from '@/config/routers';

interface Props {
    docId: string;
    entrypoint: string;
}

/**
 * 文件名中特殊字符处理
 * @params filename: 文件名称
 * @return 替换后的文件名
 */
export function replaceFileName(filename: string): string {
    const regx = /[<>|*?/"'&]/g;
    if (regx.test(filename)) {
        return filename
            .replace(/</g, '_')
            .replace(/>/g, '_')
            .replace(/|/g, '_')
            .replace(/\*/g, '_')
            .replace(/\?/g, '_')
            .replace(/\//g, '_')
            .replace(/</g, '_')
            .replace(/"/g, '_')
            .replace(/'/g, '_')
            .replace(/&/g, '_')
            .replace(/:/g, '_');
    }
    return filename;
}

/**
 * 老逻辑上传附件至rte，改为wiki服务地址
 * @param file 文件info
 * @param uploadOption 编辑器上传参数
 * @param props 业务方配置
 * @returns 返回上传结果
 */
export const uploadToRTE = async (file: any, uploadOption: any, type: 'attachment' | 'image') => {
    const {setProgress} = uploadOption;
    const docGuid = store.getData(store.KEYS.CUR_DOCUMENT).docGuid;
    const entrypoint = ServerConfig.rte;

    const requestParams = {
        file,
        fileName: replaceFileName(file.name),
        docGuid: docGuid,
        // TODO: get versionId
        versionId: '2',
    };

    const formData = new FormData();
    Object.keys(requestParams).forEach((key) => {
        formData.append(key, requestParams[key as keyof typeof requestParams]);
    });
    const {accessToken: rteToken} = store.getData(store.KEYS.CUR_DOCUMENT_TOKEN);
    const result = await sdk.serverBase.request({
        method: 'post',
        url: `${entrypoint}/wiki/attach/${type === 'image' ? 'image' : 'attachments'}/upload`,
        data: formData,
        headers: {
            Authorization: rteToken,
        },
        onUploadProgress(event: any) {
            let progress = event.loaded / event.total;
            if (progress > 0.95) {
                progress = 0.95;
            }
            if (setProgress) {
                setProgress(progress);
            }
        },
    });
    setProgress && setProgress(1);
    return {
        ...result,
        fileId: result.docGuid,
    };
};

export const getBosConfig = async (props: Props) => {
    const {docId, entrypoint} = props;

    const resSTSData = await sdk.serverBase.request({
        method: 'get',
        url: entrypoint + '/wiki/attach/attachments/ticket',
        params: {
            docGuid: docId,
        },
    });

    const {accessKeyId, bucket, secretAccessKey, endpoint, sessionToken} = resSTSData;

    const bosConfig = {
        endpoint,
        sessionToken,
        credentials: {
            ak: accessKeyId,
            sk: secretAccessKey,
        },
    };
    return {
        bosConfig,
        bucket,
    };
};

